var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('page_title_news')))]),_c('breadcrumb',[_vm._v("\n        "+_vm._s(_vm.$t('page_title_news'))+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }